import i18next from 'i18next';

i18next.addResources('es', 'ImportIcon', {
  message: 'Para ver el detalle del expediente tiene que importarlo'
});
